module.exports = __webpack_public_path__ + "media/images/landing/second/photo17-610b2b4f2c8faf985e5ba8365cafea1e.jpg";